<template>
  <DragDialog
    title="角色权限管理"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="role-permission">
      <div class="role-name-box">
        <p class="dialog-label">角色名称：</p>
        <span class="dialog-label">{{ roles[0] && roles[0].roleName }}</span>
      </div>
      <div class="permission-tree-box">
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入功能名称"
            v-model="keywords"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
        <div class="common-tree-box">
          <el-tree
            class="dialog-tree-primary"
            ref="tree"
            :data="treeData"
            :props="defaultProps"
            :default-expand-all="true"
            node-key="id"
            highlight-current
            show-checkbox
            check-strictly
            :expand-on-click-node="false"
            :filter-node-method="filterNode" />
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { getPermissionMenu, grantRole } from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',

      treeData: [],
      defaultProps: {
        children: 'childNodes',
        label: 'menuName'
      }
    }
  },
  props: {
    visible: Boolean,
    roles: Array,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      let roleInfo = this.roles[0]
      let params = { roleId: roleInfo.roleId, menuName: '' }
      this.queryRolePermission(params).then(treeData => {
        this.treeData = treeData

        let checkedKeys = this.getCheckedNodeIds(treeData)
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(checkedKeys)
        })
      })
    },
    search() {
      this.$nextTick(() => {
        this.$refs.tree.filter()
      })
    },
    filterNode(value, nodeData) {
      if (nodeData.menuName.includes(this.keywords)) {
        return true
      } else {
        return false
      }
    },
    submit() {
      let roleIds = this.roles.map(el => el.roleId)
      let node = this.$refs.tree.store._getAllNodes()
      let grantInfos = node.map(item => {
        let obj = {
          id: item.data.id,
          isGranted: item.checked,
          code: item.data.permissionCode
        }
        return obj
      })
      let params = {
        roleIds,
        grantInfos
      }
      grantRole(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.$message.success('角色授权成功！！！')
            this.cancel()
          } else {
            this.$message.error(data.errMsg)
          }
        }
      })
    },
    queryRolePermission(params) {
      return new Promise(resolve => {
        getPermissionMenu(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let treeData = response.data
              resolve(treeData)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    getCheckedNodeIds(treeData) {
      let checkedNodes = []

      const traverse = item => {
        if (item.isCheck) {
          checkedNodes.push(item.id)
        }
        if (item.childNodes && item.childNodes.length) {
          item.childNodes.forEach(childNode => {
            traverse(childNode)
          })
        }
      }

      treeData.forEach(item => {
        traverse(item)
      })

      return checkedNodes
    },
    cancel() {
      this.keywords = ''
      this.treeData = []
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.role-permission {
  color: var(--default-color);
  .role-name-box {
    display: flex;

    p {
      margin-right: 10px;
    }
  }

  .permission-tree-box {
    margin-top: 10px;
    padding: 10px;
    text-align: left;

    .common-input-box {
      width: 240px;
    }

    .common-tree-box {
      height: 500px;
      overflow-y: auto;
    }
  }
}
</style>
